import decamelize from 'decamelize'

const isObject = value => {
  return value === Object(value)
}

export const compileStyles = styles =>
  Object.entries(styles).reduce((stylesStr, [selector, ruleSet]) => {
    stylesStr += `${selector}{`
    Object.entries(ruleSet).forEach(([property, value]) => {
      if (isObject(value)) {
        const newObject = {}
        newObject[property] = value
        stylesStr += compileStyles(newObject)
      } else {
        let newStyle = `${decamelize(property, '-')}:${value};`
        // If the property is prefixed, add an additional dash at the beginning.
        const prefixes = ['Webkit', 'ms', 'Moz', 'O']
        prefixes.forEach(prefix => {
          if (property.slice(0, prefix.length) === prefix) {
            newStyle = `-${newStyle}`
          }
        })
        stylesStr += newStyle
      }
    })
    stylesStr += '}'
    return stylesStr
  }, '')
